export default class {
  hideDropDown () {
    this.$refs.cascader.$data.dropDownVisible = false
  }
}
